module.exports = __webpack_public_path__ + "fonts/iconfont.4b7663a5.eot";